import { render, staticRenderFns } from "./MainDoorExtQr.vue?vue&type=template&id=bdcc3484&scoped=true"
import script from "./MainDoorExtQr.vue?vue&type=script&lang=js"
export * from "./MainDoorExtQr.vue?vue&type=script&lang=js"
import style0 from "./MainDoorExtQr.vue?vue&type=style&index=0&id=bdcc3484&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcc3484",
  null
  
)

export default component.exports